




import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: {}
})
export default class Download extends Vue {
    constructor() {
        super();
        this.$ga.event(location.href);
        if(/Android/i.test(navigator.userAgent)) {
            window.location.assign('https://play.google.com/store/apps/details?id=com.mycarservice.mycarservice');
        } else if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
            window.location.assign('https://apps.apple.com/bg/app/my-car-service-car-management/id1433905295');
        } else {
            window.location.assign('/');
        }
    }
}
